/**
 * On phones, once the ticket card has scrolled away, a slim bar above the
 * dock keeps the way to it one tap away (or says why there is none).
 */
export function StickyCtaBar({
	visible,
	soldOut,
	seatsLabel,
	tba,
}: {
	visible: boolean
	soldOut: boolean
	seatsLabel: string | null
	tba: boolean
}) {
	if (!visible) return null

	const label = soldOut
		? 'Utseld'
		: tba
			? 'Billettar kjem'
			: seatsLabel
				? `Kjøp billett · ${seatsLabel}`
				: 'Kjøp billett'

	return (
		<div className="ev-sticky lg:hidden">
			{soldOut || tba ? (
				<span className="ev-sticky-btn" aria-disabled="true">
					{label}
				</span>
			) : (
				<a href="#billetter" className="ev-sticky-btn">
					{label}
				</a>
			)}
		</div>
	)
}
